import { LicenseStatusEnum, LicenseStatus, mapLicenseStatusToApiModel } from './LicenseStatus';

export type UpdateLicenseModel = {
    licenseNumber: string;
    status?: LicenseStatusEnum;
};

export type UpdateLicenseApiModel = {
    licenseNumber: string;
    licenseStatus?: LicenseStatus;
};

export const defaultUpdateLicenseModel: UpdateLicenseModel = {
    licenseNumber: '',
    status: LicenseStatusEnum.Blocked,
};

export const mapUpdateLicenseToApiModel = (model: UpdateLicenseModel): UpdateLicenseApiModel => ({
    licenseNumber: model.licenseNumber,
    licenseStatus: mapLicenseStatusToApiModel(model.status),
});
